module.exports = __webpack_public_path__ + "img/quest_visualization_arrows_3.4ef509aa.svg";